<template>
    <div class="baja-form">
        <template>
            <div class="text-xs-center">
                <v-dialog v-model="showForm" width="400">
                    <v-card>
                        <v-toolbar card prominent color="primary" dark>
                            <v-toolbar-title class="body-2">{{ this.formTitle }}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn icon @click="cancelForm()">
                                <v-icon medium>fa-close</v-icon>
                            </v-btn>
                        </v-toolbar>

                        <v-card-text>
                            <v-form ref="bajaForm" v-model="validBaja">
                                <v-container fluid grid-list-xl>
                                    <v-layout align-center wrap>
                                        <v-flex xs12 sm12>
                                            <v-text-field
                                                v-model="bajaItem.descripcion"
                                                label="Descripción"
                                                :error-messages="descripcionFieldErrors"
                                                :counter="255"
                                                @keydown="descripcionFieldErrors = []"
                                            >
                                            </v-text-field>
                                            <v-text-field
                                                v-model="bajaItem.finiquito"
                                                label="Finiquito"
                                                type="number"
                                                :rules="finiquitoFieldRules"
                                                :error-messages="finiquitoFieldErrors"
                                                @blur="finiquitoFieldErrors = []"
                                                >

                                            </v-text-field>

                                            <v-menu
                                                ref="menuFecha"
                                                v-model="menuFecha"
                                                :close-on-content-click="false"
                                                :nudge-right="40"
                                                lazy
                                                transition="scale-transition"
                                                offset-y
                                                full-width
                                                min-width="290px"
                                            >
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field
                                                        v-model="computedFechaFormatted"
                                                        label="Fecha de baja"
                                                        :error-messages="fechaFieldErrors"
                                                        readonly
                                                        v-on="on"
                                                        @blur="
                                                                    dateFecha = parseDate(
                                                                        bajaItem.fecha
                                                                    )
                                                                "
                                                    >
                                                    </v-text-field>
                                                </template>
                                                <v-date-picker
                                                    v-model="dateFecha"
                                                    no-title
                                                    scrollable
                                                    locale="es-es"
                                                    @input="menuFecha = false"
                                                >
                                                </v-date-picker>
                                            </v-menu>
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                            </v-form>
                        </v-card-text>

                        <v-divider></v-divider>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="red" flat @click="cancelForm()" :disabled="loading">Cancelar</v-btn>
                            <v-btn
                                color="success"
                                flat
                                @click="saveForm()"
                                :disabled="disableSaveButton"
                                :loading="loading"
                                >Guardar
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </div>
        </template>
    </div>
</template>

<script>
/* eslint-disable */
    export default {
        props: {
            formTitle: String,
            initialItem: Object,
        },
        data () {
            return {
                loading: false,
                validBaja: false,
                bajaItem: {
                    descripcion: '',
                    finiquito: 0,
                    empleado_id: this.initialItem.id,
                    fecha: this.formatDate(new Date().toISOString().substr(0, 10)),
                },
                menuFecha: false,
                dateFecha: new Date().toISOString().substr(0, 10),

                descripcionFieldRules: [
                    v => !!v || 'Debe proporcionar una descripcion',
                    v => v.length <= 255 || 'La descripcion solo puede contener 255 caracteres',
                ],
              descripcionFieldErrors: [],
              finiquitoFieldRules: [
                v => !!v || "Debe proporcionar el finiquito",
                v => v > 0 || "El finiquito debe ser mayor que 0"
              ],
              finiquitoFieldErrors: [],
              fechaFieldRules: [v => !!v || "Debe proporcionar la fecha de baja"],
              fechaFieldErrors: [],

            }
        },

        computed: {
            isNewRecord() {
                return this.initialItem === null
            },



            showForm: {
                get: function() {
                    return true
                },
                set: function () {
                    return this.cancelForm()
                }
            },
          computedFechaFormatted() {
            return this.formatDate(this.dateFecha)
          },

            disableSaveButton() {
                return this.loading || (!this.validBaja)
            }
        },

        methods:{
            saveForm() {
                this.loading = true
                this.$refs.bajaForm.validate()
                if (this.validBaja) {
                    let baja = {
                        descripcion: this.bajaItem.descripcion,
                        finiquito: this.bajaItem.finiquito,
                        empleado_id: this.bajaItem.empleado_id,
                        fecha: this.bajaItem.fecha,
                        recontratacion: 1,
                    }

                    this.$store.dispatch("TOGGLE_STATUS_EMPLEADO", baja).then(
                        result => {
                        	if (!result) {
                        		this.loading = false
                            }
                            if (result === null || result.status === 404 || result.status === 500) {
                                //cerrar el formulario si se inserto o actualizo bien (null) o cuando el elemento no existe o no hay coneccion con el servidor
                                this.$emit("formCanceled")
                            } else {
                                // El backend devolvió error de validación, pasando los errores a los campos correspondientes
                                let { data, status } = result
                                if (status === 422) {
                                    data.forEach(error => {
                                        if (error.field === "descripcion") {
                                            this.descripcionFieldErrors.push(error.message)
                                        }
                                    })
                                }
                            }
                            this.loading = false
                        }
                    )
                } else {
                    this.loading = false
                }
            },
            cancelForm() {
                this.$emit("formCanceled")
            },
          formatDate(date) {
            if (!date) return null

            const [year, month, day] = date.split("-")
            return `${day}/${month}/${year}`
          },
          parseDate(date) {
            if (!date) return null

            const [day, month, year] = date.split("/")
            return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`
          },

          created() {
            if (this.initialItem !== null) {
              // Cargando información del elemento a actualizar
              this.empleadoItem.recontratacion = this.initialItem.nombre
            }
          },

        },
      watch: {
        dateFecha: function() {
          this.bajaItem.fecha = this.formatDate(this.dateFecha)
        }
      },

    };
</script>
